import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue'
import { LocationAsRelativeRaw } from 'vue-router'
interface Props {
  text?: string
  textLink: string
  to: LocationAsRelativeRaw
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: { default: '' },
    textLink: null,
    to: null
  },
  setup(__props: any) {

const props = __props as { text: string, textLink: string, to: LocationAsRelativeRaw }



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("p", null, [
    _createTextVNode(_toDisplayString(props.text) + " ", 1),
    _createVNode(_component_router_link, {
      to: props.to
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.textLink), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})